// Setup choice step: keeps the selected card's styling and the Next button's
// destination in sync with the checked radio. The radios do the real work
// (keyboard, focus, no-JS default), so this mostly mirrors state.
//
// With data-advance-on-click (the size step), desktop has no footer: a click on
// a card, or Enter/Space on its radio, goes straight to the destination. Arrow
// keys still only move the selection - browsers fire a synthetic click for
// those (event.detail 0), which is why real clicks are told apart by detail.
const DESKTOP = window.matchMedia('(min-width: 750px)');

class HHSetupChoice extends HTMLElement {
  connectedCallback() {
    if (this._wired) return;
    this._wired = true;

    this.inputs = [...this.querySelectorAll('.hh-setup__choice-input')];
    if (!this.inputs.length) return;

    // The Next button lives in the shared shell footer, outside this element.
    this.nextBtn = this.closest('.hh-setup')?.querySelector('.hh-setup__btn--next');

    this.addEventListener('change', (event) => {
      if (event.target.classList.contains('hh-setup__choice-input')) this.sync();
    });

    if (this.hasAttribute('data-advance-on-click')) {
      this.addEventListener('click', (event) => {
        const input = event.target.closest('.hh-setup__choice')?.querySelector('.hh-setup__choice-input');
        if (input && event.detail > 0) this.advance(input);
      });
      this.addEventListener('keydown', (event) => {
        if ((event.key === 'Enter' || event.key === ' ') && event.target.classList.contains('hh-setup__choice-input')) {
          event.preventDefault();
          this.advance(event.target);
        }
      });
    }

    this.sync();
  }

  advance(input) {
    if (!DESKTOP.matches || !input.value) return;
    window.location.href = input.value;
  }

  sync() {
    const checked = this.inputs.find((i) => i.checked);
    this.inputs.forEach((input) => {
      input.closest('.hh-setup__choice')?.classList.toggle('hh-setup__choice--selected', input.checked);
    });
    if (this.nextBtn && checked?.value) this.nextBtn.setAttribute('href', checked.value);
  }
}

if (!customElements.get('hh-setup-choice')) {
  customElements.define('hh-setup-choice', HHSetupChoice);
}
